export default "__VITE_PUBLIC_ASSET__024aa7f0__"